import { fg } from '@atlaskit/platform-feature-flags';
import { type AdfParserConfig } from '@atlassian/adf-parser';

export function getParserConfig(): AdfParserConfig {
	return {
		closeBrokenContent: fg('platform_editor_ai_improved_table_parsing'),
		lenientStringParsing: fg('platform_editor_ai_lenient_string_parsing'),
		localIdTrimming: fg('platform_editor_ai_local_id_trimming'),
		autoCloseObjectOnRightBracket: fg('platform_editor_ai_less-aggro-obj-parsing'),
		liftInvalidBlockNodes: fg('platform_editor_ai_parser_lift_nodes'),
	};
};